import React, { useMemo } from 'react'
import { useQueryParams } from '../../hooks/location'
import { getQueryKeys } from '../hooks'
import { findSortColumn, sortChipText } from '../sort-label'
import { IconClose } from '../../icon/icon'

// `queryKey` must match the one the owning grid persists with (see
// table-builder/hooks.js) -- otherwise the badges report, and clear, the other
// grid's state. Omitting it keeps the historical unprefixed keys.
//
// `columns` (the grid's column definitions) and `rows` (its row data, when the
// grid holds it) let the sort chip say what the sort is in words: the
// column's header and a direction that fits it (sort-label.js).
export const QueryItems = ({ queryKey, columns, rows, onClearSort, onClearSearch }) => {
  const keys = useMemo(() => getQueryKeys(queryKey), [queryKey])
  const keyList = useMemo(() => [keys.sortCol, keys.sortDir, keys.search, keys.index], [keys])

  const params = useQueryParams(keyList)

  const sortCol = params[keys.sortCol]
  const sortDir = params[keys.sortDir]
  const search = params[keys.search]

  // A sort on a column this grid doesn't have is another grid's (two grids
  // on a page without queryKeys share the keys): the grid isn't sorted by it,
  // so there is no chip.
  const sortShown = Boolean(sortCol) && (!Array.isArray(columns) || Boolean(findSortColumn(columns, sortCol)))
  const sortText = useMemo(() => (sortShown ? sortChipText({ columns, rows, sortCol, sortDir }) : null), [sortShown, columns, rows, sortCol, sortDir])

  return (
    <React.Fragment>
      {sortShown &&
        <button type="button" className="badge text-bg-primary border-0 m-1 mt-2 ps-3 pe-2 py-2" title="Clear the sort" onClick={onClearSort}>
          {sortText} <IconClose />
        </button>}
      {search &&
        <span className="badge text-bg-primary m-1 mt-2 ps-3 pe-2 py-2 text-capitalize" style={{ cursor: 'pointer' }} onClick={onClearSearch}>
          search <IconClose />
        </span>}
    </React.Fragment>
  )
}
